module.exports = __webpack_public_path__ + "img/WDKC.d1567572.png";